if(!window.jQuery){
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
    script.onload = function() {
      setCustomCalendar();
      // fixedIssueCurrencyDisappear();
    }
    document.head.appendChild(script);
} else {
if(!window.$) {
  window.$ = window.jQuery;
}
  setCustomCalendar()
  // fixedIssueCurrencyDisappear()
}

function fixedIssueCurrencyDisappear() {
  let $ = window.jQuery
  $(function() {
      $('.form.product-purchase-form button').on('click', function () {
          let cloneEl = $('.pick_currency.mldesk').clone()
          setTimeout(() => {
              cloneEl.insertAfter($('.cart-link'))
          }, 1500)
      })

      $('.quickbuy-toggle').on('click', function () {
          setTimeout(() => {
            $('.form.product-purchase-form button').on('click', function () {
                let cloneEl = $('.pick_currency.mldesk').clone()
                setTimeout(() => {
                    cloneEl.insertAfter($('.cart-link'))
                }, 1500)
            })
          }, 2000)
      })
  })
}

function setCustomCalendar () {
  let $ = window.jQuery
  $(function() {
      $(document).on('mouseenter', function () {
        const calendar = $('.calendar-wrapper')
  
        calendar.on('mouseenter', function () {
            $(this).attr('style', 'transform: translate(0, -50%)!important')
        })
    
        calendar.on('mouseleave', function () {
            $(this).attr('style', 'transform: translate(-100%, -50%)!important')
        })
      })

      $(document).on('touchstart', function () {
        const calendar = $('.calendar-wrapper')

        $('.calendar-close').click(function () {
           $('.calendar-wrapper').attr('style', 'transform: translate(-100%, -50%)!important')
        })

        $('.calendar-toggle').click(function () {
           $('.calendar-wrapper').attr('style', 'transform: translate(0, -50%)!important')
        })
      })
  })
}
